/* AB motion: scroll reveals, image drift, breathing moments, rotating announcement, 360° atelier. Respects reduced motion. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('fx-ready');
  try { sessionStorage.setItem('ab-seen', '1'); } catch (e) {}

  /* reveals */
  var sel = '.fx-line,.fx-fade,.fx-wipe,.fx-stagger,.cine-lines';
  function show(e) { e.classList.add('is-in'); }
  var io = (!reduce && 'IntersectionObserver' in window) ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { show(x.target); io.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }) : null;
  function scan(scope) {
    [].slice.call((scope || d).querySelectorAll(sel)).forEach(function (e) {
      if (e.classList.contains('is-in') || e._abObs) return;
      if (!io) return show(e);
      e._abObs = 1; io.observe(e);
    });
  }
  scan();
  d.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  /* drift + breathe */
  var ticking = false;
  function frame() {
    ticking = false;
    var h = window.innerHeight;
    [].slice.call(d.querySelectorAll('[data-ab-breathe="true"]')).forEach(function (m) {
      var r = m.getBoundingClientRect(); if (r.bottom < 0 || r.top > h) return;
      var p = Math.min(1, Math.max(0, (h - r.top) / (h + r.height)));
      var img = m.querySelector('img'); if (img) img.style.setProperty('--breathe', (1.16 - p * 0.14).toFixed(4));
    });
    if (reduce) return;
    [].slice.call(d.querySelectorAll('.fx-drift')).forEach(function (img) {
      var f = img.closest('.fx-wipe'); if (f && !f.classList.contains('is-in')) return;
      var r = img.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > h) return;
      var p = (r.top + r.height / 2 - h / 2) / h;
      img.style.transform = 'scale(1.08) translateY(' + (p * -18).toFixed(1) + 'px)';
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  frame();

  /* rotating announcement */
  [].slice.call(d.querySelectorAll('[data-ab-announce]')).forEach(function (bar) {
    var m = [].slice.call(bar.querySelectorAll('.announce__msg')), i = 0, hold = false;
    if (m.length < 2 || reduce) return;
    ['mouseenter', 'focusin'].forEach(function (ev) { bar.addEventListener(ev, function () { hold = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { bar.addEventListener(ev, function () { hold = false; }); });
    setInterval(function () {
      if (hold || d.hidden) return;
      var a = m[i]; a.classList.remove('is-on'); a.classList.add('is-off');
      i = (i + 1) % m.length; var b = m[i]; b.classList.remove('is-off'); b.classList.add('is-on');
      setTimeout(function () { a.classList.remove('is-off'); }, 900);
    }, 4800);
  });

  /* 360° atelier */
  d.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-atelier]'); if (!chip) return;
    var sec = chip.closest('[data-ab-atelier]'); if (!sec) return;
    var id = chip.getAttribute('data-atelier');
    [].slice.call(sec.querySelectorAll('[data-atelier]')).forEach(function (b) { var on = b === chip; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    [].slice.call(sec.querySelectorAll('[data-atelier-model]')).forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-atelier-model') === id); });
    var name = sec.querySelector('[data-atelier-name]'), link = sec.querySelector('[data-atelier-link]');
    if (name) name.textContent = chip.getAttribute('data-title');
    if (link) link.setAttribute('href', chip.getAttribute('data-url'));
  });
})();
